import { gql } from '@graphql/__generated__';
import { ANALYTICS_EVENTS } from '@shared/analytics/constants';

import { DAY_MS } from '../days';

import type { Campaign } from './campaignTypes';

const RECENT_CMA = gql(/* GraphQL */ `
  query GetCampaignRecentCmaReport($userId: uuid!, $since: timestamptz!) {
    cma_reports(
      where: { created_by: { _eq: $userId }, created_at: { _gte: $since } }
      limit: 1
    ) {
      id
    }
  }
`);

const WINDOW_DAYS = 90;

// Agents with CMA reports who have not created one in 90 days (or ever) see
// the one-click "Create CMA report" button on a lead highlighted.
export const cmaOneClickFromLead: Campaign = {
  tour: 'lead-one-click-cma',
  audience: {
    tenants: 'all',
    modules: ['cma_reports'],
    recipients: 'everyone',
  },
  isEligible: async ({ client, userId }) => {
    const { data } = await client.query({
      query: RECENT_CMA,
      variables: {
        userId,
        since: new Date(Date.now() - WINDOW_DAYS * DAY_MS).toISOString(),
      },
      fetchPolicy: 'network-only',
    });
    return data != null && data.cma_reports.length === 0;
  },
  repeatAfterDays: WINDOW_DAYS,
  maxDismissals: 2,
  holdout: 0.1,
  goal: { event: ANALYTICS_EVENTS.CMA_CREATED, withinDays: 14 },
  priority: 10,
};
